export const updateTemplateForPreview = (
    htmlTemplate: string,
    keyValues: { [key: string]: any },
): string => {
    let updatedTemplate = htmlTemplate;

    Object.keys(keyValues).forEach((key) => {
        const regexTrippleBrackets = new RegExp(`{{{${key}}}}`, 'gi');
        updatedTemplate = updatedTemplate?.replace(
            regexTrippleBrackets,
            keyValues[key],
        );

        const regexDoubleBrackets = new RegExp(`{{${key}}}`, 'gi');
        updatedTemplate = updatedTemplate?.replace(
            regexDoubleBrackets,
            keyValues[key],
        );
    });
    return updatedTemplate;
};

export const extractLinkInfo = (htmlString: string) => {
    const linkRegex = /<a\s+(?:href='([^']*)'\s*)?[^>]*>(.*?)<\/a>/;

    const linkMatches = htmlString.match(linkRegex);
    const isAnchorTag = linkMatches !== null;
    if (linkMatches && linkMatches.length === 3) {
        return {
            linkValue: linkMatches[1] || '',
            textValue: linkMatches[2] || '',
            isAnchorTag: isAnchorTag,
        };
    }

    return {
        linkValue: '',
        textValue: htmlString,
        isAnchorTag,
    };
};
